import {
  Component,
  inject,
  Input,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { User, LogDTO, LogType } from 'BaseDataTypes';
import {
  Customer,
  Project,
  RequisitionStatus,
  RequisitionNumber,
  RequisitionTaskStatus,
  RequisitionStatusTranslations,
  RequisitionTaskStatusTranslations,
} from 'TimelogDataTypes';
import {
  listRow,
  ListViewComponent,
  AutoMultiselectComponent,
  getExtraBurgerMenuOptions,
  MenuOption,
} from '@standard-angular-utilities/shared-components';
import { RequisitionNumberService } from 'TimelogServices/requisition-number-service';
import { ProjectService } from 'TimelogServices/project-service';
import { CustomerService } from 'TimelogServices/customer-service';
import { MatDialog } from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';
import { RequsitionNumberDialogComponent } from '../../Dialogs/requsition-number-dialog/requsition-number-dialog.component';
import { UserService } from 'BaseServices/user-service';
import { forkJoin } from 'rxjs';
import { SharedFunctionsService } from 'BaseServices/sharedFunctions.service';
import { LogService } from 'BaseServices/log-service';
import { LogHelperService } from 'BaseServices/log-helper.service';
import {
  BaseListPageComponent,
  multiSelectFilterList,
} from 'src/app/BasePages/base-list-page/base-list-page.component';

@Component({
  selector: 'app-requisition-number',
  imports: [MatButtonModule, BaseListPageComponent],
  templateUrl: './requisition-number.component.html',
  styleUrls: [
    '../../../../../../src/app/general-styles/pages.css',
    './requisition-number.component.css',
  ],
})
export class RequisitionNumberComponent {
  @ViewChild('baseListPage')
  baseListPage!: BaseListPageComponent<RequisitionNumber>;
  @Input() customer!: Customer;

  readonly dialog = inject(MatDialog);

  requisitionNumberHeaderList: string[] = [
    'Kunde',
    'Projekt',
    'Rekvistions status',
    'Rekvisitionsnummer',
    'Dato',
    'Opgave beskrivelse',
    'Opgave status',
    'Opgave ansvarlig',
    'Kommentar',
  ];

  headerList: string[] = this.requisitionNumberHeaderList;
  logHeaderList: string[];

  requisitionNumber: RequisitionNumber[] = [];
  projects: Project[] = [];
  isHistory: boolean = false;
  selectedProjects: number[] = [];
  selectedProject: number = 0;
  customers: Customer[] = [];
  selectedCustomers: number[] = [];
  selectedCustomer: number = 0;
  requisitionNumberProjects: Project[] = [];
  requisitionStatus = RequisitionStatus;
  requisitionStatuses: any[] = [];
  requisitionNumbers: any[] = [];
  selectedReqStatus: any[] = [];
  selectedReqNumber: any[] = [];
  requisitionTaskStatus = RequisitionTaskStatus;
  requisitionTaskStatuses: any[] = [];
  selectedRequisitionTaskStatus: any[] = [];
  selectedUser: number = 0;
  selectedUsers: number[] = [];
  users: User[] = [];
  transformedUsers: User[] = [];
  extraBurgerMenuOptions: MenuOption[] = [];

  multiSelectFilterLists: multiSelectFilterList[] = [];

  constructor(
    private requsitionsNumberService: RequisitionNumberService,
    private projectService: ProjectService,
    private customerService: CustomerService,
    private userService: UserService,
    private sharedFunctionsService: SharedFunctionsService,
    private logService: LogService,
    private logHelper: LogHelperService
  ) {
    this.logHeaderList = this.logService.getLogHeaders('RequisitionNumber');
  }

  /**
   * Retrives customer and project data and updates requisitionNumber list
   */

  ngOnInit() {
    const isAdmin =
      this.userService.getSelectedRole ===
      this.userService.getUserRoleTypes.Admin;
    const customLabel = 'Skift til rekvisitionsnummer';

    this.extraBurgerMenuOptions = getExtraBurgerMenuOptions(
      isAdmin,
      this.isHistory,
      customLabel,
      this.switchDataInList.bind(this),
      () => this.extraBurgerMenuOptions[0][0],
      (newLabel: string) => {
        this.extraBurgerMenuOptions[0][0] = newLabel;
      }
    );

    this.requisitionStatuses = Object.values(this.requisitionStatus).map(
      (value, index) => ({
        id: index,
        name: RequisitionStatusTranslations[value as RequisitionStatus],
      })
    );

    this.requisitionNumbers = Object.values(this.requisitionNumber).map(
      (value, index) => ({
        id: index,
        name: value.reqNumber,
      })
    );
    this.requisitionNumber.sort((a, b) =>
      a.reqNumber.localeCompare(b.reqNumber, undefined, { numeric: true })
    );

    this.requisitionTaskStatuses = Object.values(
      this.requisitionTaskStatus
    ).map((value, index) => ({
      id: index,
      name: RequisitionTaskStatusTranslations[value as RequisitionTaskStatus],
    }));

    // Process requisition Statuses
    this.selectedReqStatus = Object.values(this.requisitionStatus).map(
      (_, index) => index
    );

    // Process Requisition Numbers
    this.selectedReqNumber = Object.values(this.requisitionNumber).map(
      (_, index) => index
    );

    // Process Requisition Task Statuses
    this.selectedRequisitionTaskStatus = Object.values(
      this.requisitionTaskStatus
    ).map((_, index) => index);

    this.updateListRequisitionNumbers(true);
  }

  /**
   * Opens a dialog with requisitionNumber details
   * If requisitionNumber is null, a dialog opens with default details, for creating a new requisitionNumber
   * @param requisitionNumber
   */
  requisitionNumberClicked = (requisitionNumber?: RequisitionNumber) => {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    if (requisitionNumber == null) {
      requisitionNumber = {
        id: 0,
        projectId: this.selectedProject,
        reqNumber: '',
        taskDescription: '',
        date: today,
        requisitionStatus: this.requisitionStatus.Open,
        requisitionTaskStatus: this.requisitionTaskStatus.NotAvailable,
        userId: this.selectedUser,
        user: this.users.find((u) => (u.id = this.selectedUser))!,
        project: this.projects.find((p) => (p.id = this.selectedProject))!,
        comment: '',
      };
    }
    let dialogref = this.dialog.open(RequsitionNumberDialogComponent, {
      data: { data: [requisitionNumber] },
    });
    dialogref.afterClosed().subscribe((result) => {
      if (result == true) {
        this.updateListRequisitionNumbers();
      }
    });
  };

  /**
   * determines if a project should be displayed based on selected customer.
   */

  updateMultiSelectFilterLists() {
    var list = [];

    var customerFilter: multiSelectFilterList = {
      Items: this.customers,
      selectedItemsIds: this.selectedCustomers,
      placeHolderText: 'Vælg kunde',
      selectedValueChange: (event: number[]) => {
        this.selectedCustomers = event;
      },
      filterFunction: (requisitionNumber: RequisitionNumber) => {
        return (
          requisitionNumber.project != null &&
          this.selectedCustomers.includes(requisitionNumber.project.customerId)
        );
      },
      HideWithHeaderIndex: 0,
    };
    list.push(customerFilter);

    var projectFilter: multiSelectFilterList = {
      Items: this.projects,
      selectedItemsIds: this.selectedProjects,
      placeHolderText: 'Vælg projekt',
      selectedValueChange: (event: number[]) => {
        this.selectedProjects = event;
      },
      filterFunction: (requisitionNumber: RequisitionNumber) => {
        return (
          requisitionNumber.project != null &&
          this.selectedProjects.includes(requisitionNumber.project.id)
        );
      },
      HideWithHeaderIndex: 1,
    };
    list.push(projectFilter);

    var statusFilter: multiSelectFilterList = {
      Items: this.requisitionStatuses,
      selectedItemsIds: this.selectedReqStatus,
      placeHolderText: 'Vælg rekvisitions status',
      selectedValueChange: (event: number[]) => {
        this.selectedReqStatus = event;
      },
      filterFunction: (requisitionNumber: RequisitionNumber) => {
        const keys = Object.keys(RequisitionStatus);
        const value = requisitionNumber.requisitionStatus;
        const index = keys.indexOf(value.toString());
        return this.selectedReqStatus.includes(index);
      },
      HideWithHeaderIndex: 2,
    };
    list.push(statusFilter);
    var reqNumberFilter: multiSelectFilterList = {
      Items: this.requisitionNumbers,
      selectedItemsIds: this.selectedReqNumber,
      placeHolderText: 'Vælg rekvisitions nummer',
      selectedValueChange: (event: number[]) => {
        this.selectedReqNumber = event;
      },
      filterFunction: (requisitionNumber: RequisitionNumber) => {
        return this.selectedReqNumber.includes(requisitionNumber.id);
      },
      HideWithHeaderIndex: 3,
    };
    list.push(reqNumberFilter);
    var taskStatusFilter: multiSelectFilterList = {
      Items: this.requisitionTaskStatuses,
      selectedItemsIds: this.selectedRequisitionTaskStatus,
      placeHolderText: 'Vælg opgave status',
      selectedValueChange: (event: number[]) => {
        this.selectedRequisitionTaskStatus = event;
      },
      filterFunction: (requisitionNumber: RequisitionNumber) => {
        const keys = Object.keys(RequisitionTaskStatus);
        const value = requisitionNumber.requisitionTaskStatus;
        const index = keys.indexOf(value.toString());
        return this.selectedRequisitionTaskStatus.includes(index);
      },
      HideWithHeaderIndex: 6,
    };
    list.push(taskStatusFilter);
    var userFilter: multiSelectFilterList = {
      Items: this.transformedUsers,
      selectedItemsIds: this.selectedUsers,
      placeHolderText: 'Vælg opgave ansvarlig',
      selectedValueChange: (event: number[]) => {
        this.selectedUsers = event;
      },
      filterFunction: (requisitionNumber: RequisitionNumber) => {
        return this.selectedUsers.includes(requisitionNumber.userId);
      },
      HideWithHeaderIndex: 7,
    };
    list.push(userFilter);
    this.multiSelectFilterLists = list;
  }
  /**
   * Function which switches the list between courses and the course event log.
   */
  switchDataInList = () => {
    if (this.isHistory) {
      this.updateListRequisitionNumbers();
      this.isHistory = false;
    } else {
      this.updateListWithLogData();
      this.isHistory = true;
    }
  };

  /**
   * Function to update list with eventlog data
   */
  updateListWithLogData() {
    this.logHelper.updateLogList(
      LogType.RequisitionNumber,
      this.getRequisitionNumberId.bind(this),
      (data) => this.baseListPage.UpdateLogListData(data)
    );
  }

  getRequisitionNumberId(id: number): string {
    return (
      this.requisitionNumbers.find((r) => r.id === id)?.name || id.toString()
    );
  }

  /**
   * function to update list with RequisitionNumbers data
   */
  updateListRequisitionNumbers(isInit: boolean = false) {
    forkJoin({
      requisitionNumbers: this.requsitionsNumberService.getRequisitionNumbers(),
      users: this.userService.getUsers(),
      projects: this.projectService.getProjects(),
      customers: this.customerService.getCustomers(),
    }).subscribe(({ requisitionNumbers, users, projects, customers }) => {
      // Process requisition numbers
      this.requisitionNumber = requisitionNumbers;

      // update filterlist with requisition numbers
      this.requisitionNumbers = this.requisitionNumber.map((rn) => ({
        id: rn.id,
        name: rn.reqNumber,
      }));

      this.requisitionNumbers.sort((a, b) =>
        a.name.localeCompare(b.name, 'da', {
          sensitivity: 'base',
          numeric: true,
        })
      );

      if (isInit) {
        this.selectedReqNumber = this.requisitionNumbers.map((x) => x.id);
      }

      // Process users
      this.users = users.filter((user) =>
        this.sharedFunctionsService
          .getDistinctIds(requisitionNumbers, (x) => x.user?.id)
          .includes(user.id)
      );
      this.users.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { numeric: true })
      );
      this.users.unshift({ id: 0, name: '' } as User);

      this.transformedUsers = this.sharedFunctionsService.transformItems(
        this.users,
        (user) => this.sharedFunctionsService.transformUserName(user)
      );

      // Process Projects
      this.projects = projects.filter((project) =>
        this.sharedFunctionsService
          .getDistinctIds(requisitionNumbers, (x) => x.project?.id)
          .includes(project.id)
      );
      this.projects.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { numeric: true })
      );

      // Process customers
      this.customers = customers.filter((customer) =>
        this.sharedFunctionsService
          .getDistinctIds(this.projects, (x) => x.customer.id)
          .includes(customer.id)
      );
      this.customers.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { numeric: true })
      );
      if (isInit) {
        this.selectedUsers = this.users.map((u) => u.id);
        this.selectedProjects = projects.map((p) => p.id);

        this.selectedCustomers = customers.map((p) => p.id);
      }

      let listData: listRow<RequisitionNumber>[] = [];
      this.updateMultiSelectFilterLists();

      requisitionNumbers.forEach((requisitionNumber) => {
        listData.push({
          object: requisitionNumber,
          id: requisitionNumber.id,
          data: [
            requisitionNumber.project?.customer?.name ?? '',
            requisitionNumber.project?.name ?? '',
            RequisitionStatusTranslations[requisitionNumber.requisitionStatus],
            requisitionNumber.reqNumber,
            new Date(requisitionNumber.date),
            requisitionNumber.taskDescription,
            RequisitionTaskStatusTranslations[
              requisitionNumber.requisitionTaskStatus
            ],
            requisitionNumber.user?.initials ?? '',
            requisitionNumber.comment ?? '',
          ],
        });
      });
      this.headerList = this.requisitionNumberHeaderList;
      this.baseListPage.UpdateListData(listData);
    });
  }
}
